












import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class CustomValueDisplay extends Vue {
  @Prop() value: any;
  @Prop({ default: false }) isPercent!: boolean;
  @Prop({ default: "td" }) tagName!: string;

  isNegative(value: string | number): boolean {
    if (!value || value === "-") return false;
    if (typeof value == "number") return Number(value) < 0;
    return parseFloat(value.replace(/,/g, "")) < 0;
  }

  formatCurrency(value: any) {
    if (value === "-") return "ー";

    return value || value === 0
      ? this.isPercent
        ? value + "%"
        : "￥" + parseInt(value).toLocaleString()
      : "";
  }
}
